import { render, staticRenderFns } from "./TwoSection.vue?vue&type=template&id=18917602&scoped=true"
import script from "./TwoSection.vue?vue&type=script&lang=js"
export * from "./TwoSection.vue?vue&type=script&lang=js"
import style0 from "./TwoSection.vue?vue&type=style&index=0&id=18917602&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18917602",
  null
  
)

export default component.exports